import storage from '@/storage'

export default {
    locale: storage.get('locale') || 'us',
    locales: ['us', 'no', 'se', 'fr'],
}
